// AI Generated
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ParamService } from '@monsido/core/param/param.service';
import moment, { Moment } from 'moment';

interface DateRange {
    startDate: Moment;
    endDate: Moment;
}

interface DateRangeOptions {
    todayAsDefaultEnd?: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class DateRangeService {
    private dateRangeOptions: { [key: string]: BehaviorSubject<any> } = {};

    constructor (private paramService: ParamService) {}

    setRangeGroup (name: string, initValue: any): BehaviorSubject<any> {
        if (!this.dateRangeOptions[name]) {
            this.dateRangeOptions[name] = new BehaviorSubject(initValue);
        }
        return this.dateRangeOptions[name];
    }

    setRangeDates (options: DateRangeOptions = {}): DateRange {
        const dateParams = this.paramService.getPrevParam();
        const date: DateRange = {
            startDate: moment(),
            endDate: moment(),
        };

        if (dateParams?.from && moment(dateParams.from).isValid()) {
            date.startDate = moment(dateParams.from);
            if (dateParams.to && moment(dateParams.to).isValid() && moment(dateParams.to).isBefore(moment().endOf('day'))) {
                date.endDate = moment(dateParams.to);
            } else {
                date.endDate = moment()
                    .subtract(options.todayAsDefaultEnd ? 0 : 1, 'days')
                    .endOf('day');
            }
        } else {
            date.endDate = moment()
                .subtract(options.todayAsDefaultEnd ? 0 : 1, 'days')
                .endOf('day');
            date.startDate = moment().subtract(7, 'days');
        }

        return date;
    }
}
